module.exports = __webpack_public_path__ + "static/media/african-explorer-logo.45994b92.png";